import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

import { onMounted, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useUsersStore } from '@/store/users';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/users/users.config';
import { useDisplay } from 'vuetify';

import Table from '@/components/views/TableView.vue';
import MobileCardsView from '@/components/views/MobileCardsView.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue';

const moduleName = 'Users';

export default /*@__PURE__*/_defineComponent({
  __name: 'Users',
  setup(__props) {

const { mobile } = useDisplay();
const isMobile = computed(() => mobile.value);

const preferencesStore = usePreferencesStore();
const usersStore = useUsersStore();

const {
  create,
  update,
  remove,
  exportCsv
} = useModuleLayoutFetcher(
  moduleName,
  (params) => usersStore.fetchUsers(params),
  {
    create: usersStore.createUser,
    update: (data) => usersStore.updateUser(data.id, data),
    remove: usersStore.deleteUser,
    //exportCsv: usersStore.exportCSV
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  // Registra los headers y defaults para ESTE módulo:
  preferencesStore.setAllModuleHeaders(moduleName, HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    moduleName,
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find(header => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

const rowActionHandlers = {
    
};

const data = computed(() => usersStore.users);

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      (_openBlock(), _createBlock(ViewsContainer, {
        moduleName: moduleName,
        listViewComponent: Table,
        filterComponent: Filter,
        data: data.value,
        config: '@/components/modules/users/users.config',
        onCreate: _unref(create),
        onUpdate: _unref(update),
        onDelete: _unref(remove),
        exportCsv: _unref(exportCsv),
        rowActionHandlers: rowActionHandlers,
        show_toolbar: true,
        show_pagination: true,
        title: {singular:'Usurio', plural:'Usurios'},
        key: moduleName
      }, null, 8, ["data", "onCreate", "onUpdate", "onDelete", "exportCsv"]))
    ]),
    _: 1
  }))
}
}

})